var _circle, _circle2, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCompletedIcon = function SvgCompletedIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 15,
    fill: "white",
    stroke: "#7CA8AF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 12,
    fill: "#7CA8AF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4385 17.878L13.7413 20.703C13.9662 20.8955 14.2509 21 14.5436 21C14.5788 21 14.6142 20.9985 14.6496 20.9955C14.9789 20.9669 15.2833 20.8072 15.4953 20.5514L21.7108 13.0555C22.1506 12.5253 22.0809 11.7356 21.5554 11.2917C21.0298 10.8482 20.2473 10.9182 19.8076 11.4486L14.3935 17.9779L12.0434 15.9677C11.5206 15.5206 10.7375 15.5854 10.2945 16.1132C9.85118 16.6408 9.91571 17.4308 10.4385 17.878Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompletedIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/completed-icon.6c0cdcdc.svg";
export { ForwardRef as ReactComponent };